import { render, staticRenderFns } from "./Holiday.vue?vue&type=template&id=59b6d463"
import script from "./Holiday.vue?vue&type=script&lang=ts"
export * from "./Holiday.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports